import axios from "axios";
import AuthService from "../lib/Auth";

const api = axios.create({
    baseURL: process.env.REACT_APP_SERVER_PATH,
});

// --------------------
// ATTACH AXIOS HELPERS
// --------------------
api.all = axios.all;
api.spread = axios.spread;
api.isCancel = axios.isCancel;
api.CancelToken = axios.CancelToken; // legacy only

// --------------------
// REQUEST INTERCEPTOR
// --------------------
api.interceptors.request.use(
    (config) => {
        const authHeader = AuthService.getAuthHeader();

        if (authHeader?.headers?.Authorization) {
            config.headers.Authorization = authHeader.headers.Authorization;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// --------------------
// RESPONSE INTERCEPTOR
// --------------------
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                await AuthService.refreshToken();

                const authHeader = AuthService.getAuthHeader();
                if (authHeader?.headers?.Authorization) {
                    originalRequest.headers.Authorization = authHeader.headers.Authorization;
                }

                return api(originalRequest);
            } catch (refreshError) {
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default api;
